"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.computeSelected = exports.idAccessor = void 0;
const idAccessor = (idKey, data) => (item) => {
    if (idKey === 'rowIndex') {
        return item && Object.prototype.hasOwnProperty.call(item, idKey)
            ? String(item[idKey])
            : String(data.indexOf(item));
    }
    if (item && Object.prototype.hasOwnProperty.call(item, idKey)) {
        return item[idKey];
    }
    throw new Error(`Grid invalid idKey: item from data collection haven't property "${idKey}"`);
};
exports.idAccessor = idAccessor;
const computeSelected = (data, selectedIds, idAccessorFn) => {
    return selectedIds.reduce((acc, selectedId) => {
        const match = data.find((item) => String(idAccessorFn(item)) === String(selectedId));
        if (match) {
            acc.push(match);
        }
        return acc;
    }, []);
};
exports.computeSelected = computeSelected;
//# sourceMappingURL=helpers.js.map